/* eslint-disable vue/html-indent */
<template>
  <div>
    <div
      v-if="draft"
      class="watermark"
    >
      watermark
    </div>
    <section class="section-blog-body">
      <div
        v-if="blog"
        class="blog"
      >
        <section
          class="title"
          :style=" { 'background-image': 'url(' + blog.data.coverImage + ')' }"
        >
          <span class="supersize archivo uppercase bold color-emphasis-2">{{ blog.data.title }}</span>
        </section>
        <div class="row">
          <div class="col-3-of-4">
            <div
              class="section-blog-body__body"
              v-html="blog.data.body"
            />
          </div>
          <div class="col-1-of-4">
            <div
              class="row"
              style="margin-bottom: 0;"
            >
              <div class="blog__share">
                Tags
              </div>
            </div> 
            <div class="blog__share">
              <span
                v-for="(tag, value) in tags"
                :key="value"
              >

                <router-link
                  class="btn-text-small"
                  :to="{ name: 'TagPage', params: {id: tag } }"
                >{{ tag }}</router-link>
              </span>
            </div>
            <div
              class="row"
              style="margin-bottom: 1rem"
            >
              <div class="blog__share">
                Share
              </div>
            </div>

            <a
              href="#"
              class="btn-text-small"
            >Facebook</a>
            <a
              href="#"
              class="btn-text-small"
            >Linked-In</a>
          </div>
        </div>
        <div class="row">
          <div class="col-3-of-4">
            <span class="section-blog-body__footer">{{ blog.data.author }}</span><span class="blog__date"> {{ blog.data.date_created['seconds'] | dateFilter }}</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {
  getFirebaseCollectionWhere,
  getFirebaseDocumentFromCollection
} from "@/functions/firebase/base";
export default {
  name: 'BlogPost',
  data () {
    return {
      id: null,
      blog: null,
      tags: [],
      draft: null
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.getBlog()
 
  },
  methods: {
    getBlog () {
      this.getBlogData()
      
    },
    async getBlogData () {
      getFirebaseCollectionWhere(process.env.VUE_APP_DB_BLOGS, 'slug_name', this.id).then(result => {
         this.blog = result.shift()
         return this.blog
        }).then((result) => this.getTags(result.id))
      return this.blog
    },
    async getTags (id) {
      console.log(this.blog.id)
      getFirebaseDocumentFromCollection(process.env.VUE_APP_DB_TAGS_POST, id).then(result => {
        this.tags = result.shift().tags
      })
    }
  }
}
</script>
